export default "__VITE_ASSET__8d920349__"